const NS = 'PersonalisedDashboardWidget';
const CLS = 'personalisedDashboardWidget';

import * as Api from '../../../../global/js/api';
import { BookmarkSquareWidget } from '../../bookmarkSquareWidget/js/bookmarkSquareWidget';
import Handlebars from 'handlebars';
import PerfectScrollbar from 'perfect-scrollbar';

export class PersonalisedDashboardWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$closeBtn = this.$element.find(`.${CLS}-header-close`);
		this.$overlay = this.$element.find(`.${CLS}-overlay`);
		this.bookmarksApi = this.$element.data('bookmarksApi');
		this.loadingSpinner = $('.loading-spinner');
		this.$selects = this.$element.find(`.${CLS}-filters select`);
		this.$btnClearFilters = this.$element.find(`.${CLS}-btn--clearFilters`);
		this.$noBookmarks = this.$element.find(`.${CLS}-noBookmarks`);

		this.setItemTemplate();

		this.$closeBtn.on('click', () => {
			this.$element.removeClass('active');
		});

		this.$overlay.on('click', () => {
			this.$element.removeClass('active');
		});

		// handle filters changes
		this.$selects.on('change', (e) => {
			if(!this.isClear) {
				this.getItems(e.currentTarget);
			}
		});

		// Clear Filters
		this.$btnClearFilters.on('click', (e) => {
			// Clear select values
			this.$selects.each((index, element) => {
				this.isClear = true;
				$(element).val($(element).find('option:first').attr('value')).change();
			});

			this.isClear = false;

			this.getItems(e.currentTarget);
		});

		// when it's opened (custom events from the topbar widget)
		this.$element.on('opened', () => {
			// check if the current tab has any loaded data
			this.getActiveTabAndInitBookmarksCall();
		});

		// in case the dashboard is visible on load
		if(this.$element.hasClass('active')) {
			this.$element.trigger('opened');
		}

		// when content tabs change, fetch the content
		this.$element.on('shown.bs.tab', `.${CLS}-bookmarksTabsContent [data-toggle="tab"]`, () => {
			this.getActiveTabAndInitBookmarksCall();
		});

		// when any tabs change, activate the first tabbed content if any
		this.$element.on('shown.bs.tab', `.${CLS}-tabs [data-toggle="tab"]`, (e) => {
			this.activateFirstSubTab(e);
		});

		// when a bookmark is removed
		this.$element.on('bookmarkRemoved', (e, bookmarkId) => {
			let $item = this.$element.find(`.bookmarkSquareWidget[data-id="${bookmarkId}"]`).closest('.mediaItemBlock');
			$item.fadeOut(500, () => {
				$item.parent().remove();
			});
		});

		// update details form submit
		this.$element.on('submit', '#updatePersonalDetailsForm', (e) => {
			e.preventDefault();

			let $form = $(e.currentTarget);
			let data = {};

			$form.find('.success-messages, .error-messages').removeClass('is-active').text('');
			this.loadingSpinner.addClass('is-active');

			$form.find('input, select').each((index, element) => {
				// Ignore disabled field. Disabled form is not meant to flow through form submission.
				if ($(element).prop('disabled')) {
					return;
				}
				// Ignore unchecked radiobutton, otherwise this might override the checked radiobutton.
				if ($(element).prop('type') === 'radio' && !$(element).prop("checked")) {
					return;
				}
				data[$(element).attr('name')] = $(element).val();
			});

			Api.callApi($form.attr('action'), data).then((data) => {
				if(data.isSucceed === true) {
					$form.find('.success-messages').addClass('is-active').text(data.message);
				}
				else {
					$form.find('.error-messages').addClass('is-active').text(data.message);
				}

				this.loadingSpinner.removeClass('is-active');
			}, (data) => {
				$form.find('.error-messages').addClass('is-active').text((data.message) ? data.message : 'Your request was not successful. Please check your info and try again.');
				this.loadingSpinner.removeClass('is-active');
			});
		});

		this.$element.find(`.${CLS}-tabs`).each((index, element) => {
			new PerfectScrollbar(element);
		});

		this.$element.on('click', '#editShareHolderDetails', () => {
			this.$element.find('#levyPrayer-yes').trigger('click');
			this.$element.find('.shareholder-edit-control').addClass('d-none');

			this.$element.find('#isShareHolderEditActive').val('true');

			// in case ids core isn't loaded yet
			setTimeout(() => {
				this.$element.find('.ids-shareholder-form').removeClass('hidden');
			}, 250);
		});

		this.$element.on('click', '.shareholder-cancel', () => {
			this.$element.find('#levyPrayer-no').trigger('click');
			this.$element.find('.shareholder-edit-control').removeClass('d-none');

			this.$element.find('#isShareHolderEditActive').val('false');

			// close ids error if any
			if(this.$element.find('.ids-error-wrap .ids-icon-close').length > 0) {
				this.$element.find('.ids-error-wrap .ids-icon-close').trigger('click');
			}

			// in case ids core isn't loaded yet
			setTimeout(() => {
				this.$element.find('.ids-shareholder-form').addClass('hidden');
			}, 250);
		});
	}

	getActiveTabAndInitBookmarksCall() {
		let $activeTab = this.$element.find(`.${CLS}-bookmarksTabsContent:visible .tab-pane.active`);

		if(!$activeTab.data('bookmarksLoaded')) {
			if($activeTab.find(`.${CLS}-btn--clearFilters`).length > 0) {
				$activeTab.find(`.${CLS}-btn--clearFilters`).trigger('click');
			}
			else {
				this.getItems($activeTab.find(`.${CLS}-itemsList`));
			}
		}
	}

	activateFirstSubTab(e) {
		let $tab = this.$element.find($(e.target).attr('href'));
		let $tabToggles = $tab.find('[data-toggle="tab"]');
		let $activeTabToggles = $tab.find('[data-toggle="tab"].active');

		// check if we have inner tabs
		if($tabToggles.length > 0) {
			// check if we have no active tabs
			if($activeTabToggles.length === 0) {
				$tabToggles.first().trigger('click');
			}
		}
	}

	getItems(el) {
		this.loadingSpinner.addClass('is-active');

		this.$parentTab = $(el).closest('.tab-pane');
		this.$itemsList = this.$parentTab.find(`.${CLS}-itemsList`);

		this.$itemsList.empty();
		this.params = {};

		this.$parentTab.find(`.${CLS}-filters select`).each((index, element) => {
			this.params[$(element).attr('name')] = $(element).val();
		});

		this.params['bookmarkType'] = this.$parentTab.data('bookmarkType');

		Api.callApi(this.bookmarksApi, this.params).then((data) => {
			let items = data.results;
			if(items.length > 0) {
				items.forEach((item) => {
					item.bookmarkSquareWidget = this.bookmarkSquareWidget;
					item.bookmarkSquareWidget.id = item['bookmarkId'];
					item.bookmarkSquareWidget.isMarked = item['isBookmarked'];

					let itemMarkup = this.itemTemplate(item);
					this.$itemsList.append(`
						<div class="col-12 col-md-6">
							${itemMarkup}
						</div>
					`);

					new BookmarkSquareWidget(this.$itemsList.find('.bookmarkSquareWidget').last()[0]);
				});
			}
			else {
				this.$noBookmarks.clone().removeClass('d-none').appendTo(this.$itemsList);
			}

			this.loadingSpinner.removeClass('is-active');
			this.$parentTab.data('bookmarksLoaded', true);
		}, () => {
			this.loadingSpinner.removeClass('is-active');
		});
	}

	setItemTemplate() {
		let mediaItemBlock = require('../../../blocks/mediaItemBlock/tmpl/mediaItemBlock.hbs');
		let bookmarkSquareWidget = require('../../bookmarkSquareWidget/tmpl/bookmarkSquareWidget.hbs');

		Handlebars.registerPartial('mediaItemBlock', mediaItemBlock);
		Handlebars.registerPartial('bookmarkSquareWidget', bookmarkSquareWidget);

		this.bookmarkSquareWidget = {
			wg: 'bookmarkSquareWidget',
			ns: 'BookmarkSquareWidget',
			bookmarkApi: this.$element.data('bookmarkApi'),
			unbookmarkApi: this.$element.data('unbookmarkApi'),
			bookmarkMessage: 'Item Saved!'
		};

		let template = `
			{{> mediaItemBlock
				blk="mediaItemBlock"
				ns="MediaItemBlock"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.itemTemplate = Handlebars.template(precompiled);
	}
}
